<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :width="width" :height="height"
         viewBox="0 0 36 36" style="enable-background:new 0 0 36 36;" xml:space="preserve">
        <g>
	<defs>
		<rect id="SVGID_1_" width="36" height="36"/>
	</defs>
            <g id="info" >
                <g id="Group_14556" transform="translate(4679 7762)">
			<g id="Ellipse_1049" transform="translate(-4679 -7762)">
				<circle style="fill: transparent;" cx="18" cy="18" r="18"/>
                <g>
					<path class="svg-outline-color" d="M18,36C8.1,36,0,27.9,0,18C0,8.1,8.1,0,18,0c9.9,0,18,8.1,18,18C36,27.9,27.9,36,18,36z M18,1
						C8.6,1,1,8.6,1,18s7.6,17,17,17s17-7.6,17-17S27.4,1,18,1z"/>
				</g>
			</g>
                    <path class="svg-secondary-color" d="M-4661-7747c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S-4662.1-7747-4661-7747z M-4659-7738.5v-7.5h-6v1.5h2v6
				h-2v1.5h8v-1.5H-4659z"/>
		</g>
	</g>
</g>
</svg>
</template>

<script>
export default {
    name: "medicalDeviceInfoIcon",
    props: {
        width: {
            type: Number,
            default: 36
        },
        height: {
            type: Number,
            default: 36
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/medicalDeviceInfoIcon.vue